import React, { useCallback, useState } from 'react';
import { usePaginatedQuery } from 'react-query';
import { Card, Table } from 'antd';
import { getTransactions } from 'api/transactions';
import { columns } from 'configs/columns/transactions';

const Transactions = () => {
  const [page, setPage] = useState(1);

  const transactionsResolver = useCallback(
    async (key, page) => {
      const { body } = await getTransactions(page);

      return { transactions: body?.data || [], pagination: body?.pagination || {} };
    },
    [page],
  );

  const { resolvedData, latestData, status } = usePaginatedQuery(
    ['get-transactions', page],
    transactionsResolver,
  );

  const onPageChange = page => {
    (!latestData || !latestData?.pagination?.next) && setPage(page);
  };

  const pagination = {
    current: resolvedData?.pagination?.current,
    hideOnSinglePage: true,
    onChange: page => onPageChange(page),
    pageSize: 20,
    showSizeChanger: false,
    total: resolvedData?.pagination?.pages ?? 0,
  };

  return (
    <Card title="Pagos">
      <Table
        columns={columns}
        loading={status.loading}
        dataSource={resolvedData?.transactions}
        pagination={pagination}
        rowKey={({ id }) => id}
      />
    </Card>
  );
};

export default Transactions;
